(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function boot(){
    var items = document.querySelectorAll('.tg-rv:not(.tg-bound)');
    Array.prototype.forEach.call(items, function(el){ el.classList.add('tg-bound'); });
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function(el){ el.classList.add('tg-in'); });
      return;
    }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('tg-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(items, function(el){ io.observe(el); });
  }
  var shots = [], ticking = false;
  function drift(){
    var y = window.pageYOffset || document.documentElement.scrollTop;
    shots.forEach(function(s){
      var t = Math.min(y, 700);
      s.style.transform = 'translateY(' + (t * 0.10) + 'px) scale(' + (1 - t * 0.00009) + ')';
    });
    ticking = false;
  }
  function init(){
    boot();
    if(!reduce){
      shots = Array.prototype.slice.call(document.querySelectorAll('[data-tg-parallax]'));
      if(shots.length){
        window.addEventListener('scroll', function(){
          if(!ticking){ ticking = true; window.requestAnimationFrame(drift); }
        }, { passive:true });
        drift();
      }
    }
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', boot);
})();
